import { useContext } from 'react';
import { CoreContext } from '../context/CursorCoreContextProvider';
import { CursorCoreAPI } from './useCursorCore';

function useCursorContext(): CursorCoreAPI {
  return useContext(CoreContext);
}

export default useCursorContext;
